import Base from './base'

export default class ExternalApiKey extends Base {
  list(clientId: string) {
    return this.apiClient.get(`clients/${clientId}/external-api-keys`)
  }

  create(clientId: string, data: { label: string; expiresAt?: string }) {
    return this.apiClient.post(`clients/${clientId}/external-api-keys`, data)
  }

  revoke(clientId: string, id: string) {
    return this.apiClient.put(`clients/${clientId}/external-api-keys/${id}/revoke`)
  }
}
